<template>
  <div>
    <template v-if="warnings && warnings.length > 0">
      <warning
        v-for="(warning, index) in warnings"
        :key="index"
        :warning="warning"
      />
    </template>
  </div>
</template>
<script>
import Warning from '@/components/dashboard/Warning/'

export default {
  props: {
    lang: {
      type: String,
      default: 'en-IN'
    }
  },
  mounted() {
    this.fetchWarnings()
  },
  data() {
    return {
      warnings: []
    }
  },
  computed: {
    contentType() {
      if (this.lang === 'es-MX' || this.lang === 'en-MX') {
        return 'portalWarningsMx'
      }
      return 'portalWarnings'
    }
  },
  methods: {
    async fetchWarnings() {
      const {
        VUE_APP_CTF_SPACE_ID,
        VUE_APP_CTF_ENVIRONMENT,
        VUE_APP_CTF_TOKEN
      } = process.env
      const url = `https://cdn.contentful.com/spaces/${VUE_APP_CTF_SPACE_ID}/environments/${VUE_APP_CTF_ENVIRONMENT}/entries`
      const queryParams = `?access_token=${VUE_APP_CTF_TOKEN}&content_type=${this.contentType}&order=sys.createdAt`
      const res = await fetch(url + queryParams)
      const entries = await res.json()
      if (entries && entries.items && entries.items.length) {
        this.$mpTrack('Dashboard - Warnings rendered', {
          count: entries.items.length
        })
      }
      this.warnings =
        entries &&
        entries.items &&
        entries.items.map((item) => {
          if (this.lang === 'es-MX') {
            return {
              title: item.fields.titleMx,
              desc: item.fields.descMx,
              subtext: item.fields.subtextMx,
              button: item.fields.buttonMx
            }
          }
          return item.fields
        })
    }
  },
  components: {
    Warning
  }
}
</script>
